import { outdatedBrowserInfo } from './components';
import type { AppConfiguration } from './models';
import { fetchTranslations, buildTranlationsQueryParams } from './utils';

export interface Config {
  apiUrl?: string;
  tenant: string;
}

export const app = ({ config }: AppConfiguration) => {
  if (!config) {
    throw new Error('No config provided!');
  }
  const { tenant, apiUrl } = JSON.parse(config) as Config;

  if (!tenant) {
    throw new Error('Missing config values!');
  }

  fetchTranslations(
    `${apiUrl ?? ''}/system/ajax/Localization/Translate?${buildTranlationsQueryParams()}`,
    {
      tenant,
    },
    (translations) => {
      outdatedBrowserInfo(translations);
    },
    () => {
      // silence
    },
  );
};
